import { render, staticRenderFns } from "./FileInfo.vue?vue&type=template&id=3214bca8&scoped=true"
import script from "./FileInfo.vue?vue&type=script&lang=js"
export * from "./FileInfo.vue?vue&type=script&lang=js"
import style0 from "./FileInfo.vue?vue&type=style&index=0&id=3214bca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3214bca8",
  null
  
)

export default component.exports